// Satu-satunya sumber warna kursi. Legenda dan denah sama-sama membaca dari
// sini supaya keterangan warna tidak pernah melenceng dari yang digambar.
//
// Semuanya dirancang di atas kanvas gelap (--map-bg di style.css): kursi
// tersedia terang, yang tidak tersedia meredup ke belakang, dan kursi
// pelanggan paling menonjol.
export const SEAT_COLORS = {
  yours: '#ff4d4f',
  available: '#f5efe4',
  paid: '#f2c661',
  unavailable: '#5a4b4f',
  // Blok penanda dari API (ticket_id 8888) — bukan kursi yang bisa dipesan.
  reference: '#33517f',
};

// ticket_id yang dipakai API untuk menandai area non-kursi.
export const REFERENCE_TICKET_ID = 8888;

// Label yang digambar di atas area tersebut. Kalau nanti API memakai kode ini
// untuk area lain, cukup ubah di sini.
export const REFERENCE_AREA_LABEL = 'Lidah Panggung';

// Warna teks nomor kursi, dipilih agar kontras dengan isian kursinya.
export const SEAT_LABEL_COLORS = {
  onLight: '#2b1704',
  onDark: '#ffffff',
};

export const SEAT_LEGEND = [
  { key: 'yours', label: 'Kursi Anda' },
  { key: 'available', label: 'Tersedia' },
  { key: 'paid', label: 'Best view (berbayar)' },
  { key: 'unavailable', label: 'Tidak tersedia' },
];
